import { skipToken } from '@reduxjs/toolkit/query';
import { CommanderAPI } from '../CommanderAPI';
import { ITypeRequest } from '../../../../theme/ui/Dashboard/Dashboard.model';
import { DeviceStatusMapAPIResponse } from '../deviceStatus.model';
import { M_SECONDS_POOLING_INTERVAL_DATA } from '../../../store/Store.constants';
import useAggregatedGetDevicesConnectionStatusBySubWorkSpaces from './useAggregatedGetDevicesConnectionStatusBySubworkspaces';

function selectFromResult<T extends { data?: DeviceStatusMapAPIResponse[] }>({
  data,
  ...rest
}: T) {
  return {
    ...rest,
    data: data?.filter((device) => device.mqttConnected !== true),
  };
}
interface IUseCommanderOfflineProps {
  groupId?: string;
  workspaceId?: string;
  typeRequest: ITypeRequest;
}
function useCommanderOffline(props: IUseCommanderOfflineProps) {
  const { typeRequest, groupId, workspaceId } = props;
  const workspacesDevicesConnectionStatusResponse =
    useAggregatedGetDevicesConnectionStatusBySubWorkSpaces(
      typeRequest === 'workspaces'
    );

  const userDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusByUserQuery(undefined, {
      pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
      skip: typeRequest !== 'user',
      selectFromResult,
    });

  const groupDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusByGroupQuery(
      groupId ?? skipToken,
      {
        pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
        skip: typeRequest !== 'group',
        selectFromResult,
      }
    );

  const workspaceDevicesConnectionStatusResponse =
    CommanderAPI.useGetDevicesConnectionStatusByWorkspaceQuery(
      workspaceId ?? skipToken,
      {
        pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
        skip: typeRequest !== 'workspace',
        selectFromResult,
      }
    );

  switch (typeRequest) {
    case 'user':
      return userDevicesConnectionStatusResponse;
    case 'group':
      return groupDevicesConnectionStatusResponse;
    case 'workspace':
      return workspaceDevicesConnectionStatusResponse;
    case 'workspaces':
      return workspacesDevicesConnectionStatusResponse;
    default:
      return userDevicesConnectionStatusResponse;
  }
}

export default useCommanderOffline;
